// extracted by mini-css-extract-plugin
export default {"wrapper":"jWOkUR","header":"Tcx4PI","ok-button":"AxqreY","okButton":"AxqreY","sub-footer":"ODqoiu","subFooter":"ODqoiu","mobileLogoutBtn":"qUgcTM"};